import { KYMW1600Model } from '../kymw1600.model';
import { UpdateImageInfoModel } from '../vo/update-image-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用画像情報取得要求サービス
 *
 * @export UpdateImageInfoService
 * @class UpdateImageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateImageInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof UpdateImageInfoService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof UpdateImageInfoService
   */
  private vo: UpdateImageInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageId: this.vo.imageId,
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
        ProcessInstruct: this.vo.processInstruct,
        Remarks: this.vo.remarks,
        CookingExPublish: this.vo.cookingExPublish,
        Priority: this.vo.priority,
        CookingDiv: this.vo.cookingDiv,
        CookingName: this.vo.cookingName,
        MaterialName: this.vo.materialName,
        KeyWord: this.vo.keyWord,
        EventId: this.vo.eventId,
        PhotoContentsDiv: this.vo.photoContentsDiv,
        PhotoInstructContents: this.vo.photoInstructContents,
        PhotoSchedule: this.vo.photoSchedule,
        PhotoStudioId: this.vo.photoStudioId,
        TextCaption: this.vo.textCaption
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateImageInfoService
   */
  execute(model: KYMW1600Model, vo: UpdateImageInfoModel): void {
    this.model = model;
    this.vo = vo;
    this.send('KYMW16UpdateImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateImageInfoService
   */
  success(data: any): void {
    this.model.imageInfoDetailChangeFlg = false;
  }
}
